
export const version = "1.0.5"; // ES6 module syntax